/** ko 国家/地区落地页 */
export default {
  "label": "Korea",
  "path": "/locations/free-korea-vpn/",
  "hreflang": "ko",
  "htmlLang": "ko",
  "title": "Secure VPN – 무료 한국 VPN 및 한국 IP",
  "description": "Secure VPN으로 인터넷 연결을 보호하고 한국 IP 주소를 얻는 방법과 VPN 연결 설정 방법을 알아보세요. 이용 가능한 서버와 연결 방법을 확인하세요.",
  "h1": "무료 한국 VPN으로 한국 IP 주소 보호",
  "heroLead": "Secure VPN을 다운로드하고 웹 브라우징, 스트리밍, 게임과 온라인 개인정보 보호를 위한 빠른 암호화 연결을 이용하세요.",
  "heroPoints": [
    "1대 기기 보호",
    "로그·광고 없음",
    "무제한 무료",
    "글로벌 VPN 서버"
  ],
  "heroCtaLabel": "APK 다운로드",
  "privacyTitle": "무료 VPN으로 개인정보 보호",
  "privacyLead": "Secure VPN은 인터넷을 더 안전하게 사용하도록 돕는 간단한 VPN 앱입니다. 한 번만 눌러 보안 서버에 연결하고 IP 주소를 숨기며 공용 Wi-Fi, 모바일 네트워크와 집 인터넷을 더 안전하게 이용할 수 있습니다. 복잡한 설정 없이 빠른 보호를 원하는 사용자에게 적합합니다.",
  "privacySubtitle": "주요 혜택",
  "privacyBenefits": [
    {
      "title": "100% 무료, 무제한",
      "desc": "일일 데이터 제한과 숨은 비용 없이 VPN을 이용하세요."
    },
    {
      "title": "공용 Wi-Fi 보호",
      "desc": "카페, 공항, 호텔과 공유 네트워크를 더 안전하게 이용하세요."
    },
    {
      "title": "무로그 정책",
      "desc": "VPN 사용 중 방문한 웹사이트 기록을 보관하지 않습니다."
    }
  ],
  "featuresTitle": "Secure 무료 VPN으로 가능한 것",
  "featureCards": [
    {
      "title": "암호화된 온라인 보안",
      "desc": "강력한 암호화로 개인 데이터와 인터넷 트래픽을 안전하게 보호하세요."
    },
    {
      "title": "빠른 글로벌 서버",
      "desc": "전 세계 고속 VPN 서버에서 웹 서핑, 스트리밍과 일상 인터넷을 이용하세요."
    },
    {
      "title": "다양한 서버 위치",
      "desc": "여러 국가의 서버를 선택하고 어디서나 안정적으로 연결하세요."
    },
    {
      "title": "한 번에 연결",
      "desc": "복잡한 설정 없이 한 번 눌러 최적의 서버에 즉시 연결하세요."
    },
    {
      "title": "전 세계 서버",
      "desc": "필요할 때 언제든 빠르고 안전하게 글로벌 VPN 서버를 이용하세요."
    },
    {
      "title": "원활한 스트리밍",
      "desc": "동영상, 라이브 방송과 온라인 콘텐츠를 안정적으로 즐기세요."
    },
    {
      "title": "고속 성능",
      "desc": "최적화된 서버가 웹 서핑과 게임에 빠르고 안정적인 연결을 제공합니다."
    },
    {
      "title": "100% 무료, 무제한",
      "desc": "일일 데이터 제한과 숨은 비용 없이 VPN을 이용하세요."
    }
  ],
  "extraTitle": "Secure VPN을 선택하는 더 많은 이유",
  "extraItems": [
    "가볍고 사용하기 쉬움",
    "공용 Wi-Fi 보호",
    "IP 주소 숨기기",
    "제한 없는 브라우징",
    "빠르고 안정적인 서버"
  ],
  "extraCta": "APK 다운로드",
  "extraPlayPrefix": "Download from",
  "dailyTitle": "일상에서 Secure VPN 활용하기",
  "dailyScenes": [
    {
      "title": "네트워크 제한 없는 게임",
      "tags": [
        "PUBG Mobile",
        "Call of Duty: Mobile",
        "Free Fire",
        "Mobile Legends"
      ]
    },
    {
      "title": "안전한 영상 통화와 메시지",
      "tags": [
        "WhatsApp",
        "Telegram",
        "Skype",
        "Viber"
      ]
    },
    {
      "title": "공용 Wi-Fi에서 안전하게 연결",
      "tags": [
        "공용 Wi-Fi",
        "직장",
        "학교",
        "공항"
      ]
    },
    {
      "title": "온라인 개인정보 보호",
      "tags": [
        "강력한 암호화",
        "IP 주소 숨기기",
        "무로그 정책",
        "ISP로부터 보호"
      ]
    }
  ],
  "installTitle": "Secure VPN 앱 다운로드 및 설치 방법",
  "installLead": "다음 간단한 단계를 따라 하세요.",
  "installSteps": [
    {
      "title": "다운로드 페이지 열기",
      "desc": "Secure VPN 다운로드 페이지나 신뢰할 수 있는 앱 스토어에서 최신 버전을 확인하세요."
    },
    {
      "title": "Secure VPN 다운로드",
      "desc": "다운로드 버튼을 누르고 APK 또는 앱 파일 다운로드가 끝날 때까지 기다리세요."
    },
    {
      "title": "설치 권한 허용",
      "desc": "APK 파일을 받은 경우 브라우저나 파일 관리자에 알 수 없는 앱 설치 권한을 허용하세요."
    },
    {
      "title": "앱 설치",
      "desc": "다운로드한 파일을 열고 설치를 눌러 설치를 완료하세요."
    },
    {
      "title": "실행 및 연결",
      "desc": "Secure VPN을 열고 서버를 선택한 뒤 연결을 눌러 보안 연결을 시작하세요."
    },
    {
      "title": "안전하게 이용",
      "desc": "이제 인터넷 트래픽이 보호됩니다. 더 안전하게 웹 서핑, 스트리밍과 게임을 즐기세요."
    }
  ],
  "installCta": "APK 다운로드",
  "compareTitle": "Secure VPN 앱과 무료 웹 프록시 비교",
  "compareLead": "Secure VPN 앱과 무료 웹 프록시는 모두 더 안전한 인터넷 사용을 돕지만 작동 방식은 다릅니다. VPN 앱은 암호화 연결로 기기 전체를 보호하고, 웹 프록시는 주로 브라우저의 빠른 접속을 위한 도구입니다.",
  "compareNote": "일상적인 인터넷 사용에는 Secure VPN 앱이 더 완전하고 안정적인 보안 연결을 제공합니다.",
  "compareHeaders": [
    "기능",
    "Secure VPN 앱",
    "무료 웹 프록시"
  ],
  "compareRows": [
    {
      "feature": "설치",
      "vpn": "간단한 앱 설치",
      "proxy": "설치 필요 없음"
    },
    {
      "feature": "사용 범위",
      "vpn": "모든 앱과 웹사이트 보호",
      "proxy": "브라우저에서만 작동"
    },
    {
      "feature": "개인정보 보호",
      "vpn": "강력한 암호화와 보안 연결",
      "proxy": "기본적인 브라우징 보호"
    },
    {
      "feature": "연결 속도",
      "vpn": "최적화된 VPN 서버",
      "proxy": "프록시 서버에 따라 다름"
    },
    {
      "feature": "기기 보호",
      "vpn": "기기 전체 보호",
      "proxy": "브라우저 수준만 보호"
    }
  ],
  "privacyChoiceTitle": "어떤 것을 선택할까요?",
  "privacyChoiceP1": "더 강한 개인정보 보호, 빠른 속도와 기기 전체 보호가 필요할 때 적합합니다.더 강한 개인정보 보호, 빠른 속도와 기기 전체 보호가 필요할 때 적합합니다.",
  "privacyChoiceP2": "간단한 작업을 위한 일시적인 브라우저 접속만 필요할 때 적합합니다.",
  "privacyChoiceP3": "일상적인 인터넷 사용에는 Secure VPN 앱이 더 완전하고 안정적인 보안 연결을 제공합니다.",
  "reviewsTitle": "사용자가 신뢰합니다",
  "reviewsLead": "전 세계 사용자가 빠르고 안정적이며 안전한 연결을 위해 Secure VPN을 선택합니다. 신뢰할 수 있는 서버와 개인정보 보호 기능으로 매일 안전하게 브라우징, 스트리밍과 게임을 즐길 수 있습니다.",
  "reviews": [
    {
      "name": "James",
      "text": "연결이 빠르고 사용하기 쉽습니다. 어디서든 안전하게 인터넷을 이용할 수 있어요."
    },
    {
      "name": "Emily",
      "text": "Secure VPN이 원활하게 작동하고 공용 Wi-Fi에서도 연결이 안정적입니다."
    },
    {
      "name": "Daniel",
      "text": "스트리밍, 게임과 일상 사용에 속도와 서버 안정성이 좋습니다."
    }
  ],
  "faqTitle": "자주 묻는 질문",
  "faqs": [
    {
      "q": "VPN을 사용하면 인터넷이 느려지나요?",
      "a": "트래픽이 보안 서버를 거치므로 속도가 조금 낮아질 수 있습니다. 대부분 차이는 작고 일반적인 브라우징, 스트리밍과 앱 사용에는 문제가 없습니다."
    },
    {
      "q": "SecureVPN은 안전한가요?",
      "a": "SecureVPN은 연결을 암호화하고 IP 주소를 숨겨 개인정보를 보호합니다. 신뢰할 수 있는 출처에서 앱을 받고 개인정보 처리방침을 확인하세요."
    },
    {
      "q": "VPN 사용은 합법인가요?",
      "a": "대부분 국가에서 VPN은 개인정보와 보안을 위해 합법적으로 사용됩니다. 거주 지역의 법과 규정을 따라야 합니다."
    },
    {
      "q": "얼마나 오래 연결할 수 있나요?",
      "a": "보호된 인터넷 연결이 필요한 동안 SecureVPN을 계속 사용할 수 있습니다. 연결 제한은 앱 버전과 서비스 조건에 따라 다를 수 있습니다."
    },
    {
      "q": "Secure VPN은 어떻게 사용하나요?",
      "a": "Secure VPN을 설치하고 앱을 연 뒤 서버를 선택하고 연결 버튼을 누르세요. 연결되면 인터넷 트래픽이 VPN을 통해 전송됩니다."
    },
    {
      "q": "VPN이 배터리에 영향을 주나요?",
      "a": "연결을 유지하므로 약간의 배터리를 더 사용할 수 있습니다. 대부분 일상 사용에 체감될 정도의 영향은 없습니다."
    }
  ]
};
